module.exports = __webpack_public_path__ + "static/media/iloop.5aee1ee7.svg";